import { ActiveModelSerializer } from 'miragejs';

export default class extends ActiveModelSerializer {
  attrs = ['id', 'lastSyncedAt', 'linkUrl', 'organizationId', 'provider', 'status'];
  serializeIds = 'always';
}
